'use client'

import { useEffect, useState, useCallback } from 'react'
import { usePathname } from 'next/navigation'

export default function NavigationLoader() {
  const pathname = usePathname()
  const [loading, setLoading] = useState(false)
  const [progress, setProgress] = useState(0)
  const [prevPathname, setPrevPathname] = useState(pathname)

  // Reset on route change (adjust state during render — React 19 pattern)
  if (prevPathname !== pathname) {
    setPrevPathname(pathname)
    setLoading(false)
    setProgress(0)
  }

  // Animate progress while loading
  useEffect(() => {
    if (!loading) return
    const t1 = setTimeout(() => setProgress(45), 150)
    const t2 = setTimeout(() => setProgress(70), 600)
    const t3 = setTimeout(() => setProgress(85), 1500)
    return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3) }
  }, [loading])

  const start = useCallback(() => { setLoading(true); setProgress(15) }, [])

  // Expose start function via context-free approach: custom event
  useEffect(() => {
    const handler = () => start()
    window.addEventListener('nav-start', handler)
    return () => window.removeEventListener('nav-start', handler)
  }, [start])

  if (!loading) return null

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[9999] h-[3px]"
      style={{ backgroundColor: 'transparent' }}
    >
      <div
        className="h-full transition-all duration-300 ease-out"
        style={{
          width: `${progress}%`,
          backgroundColor: 'var(--color-accent)',
          boxShadow: '0 0 8px var(--color-accent)',
        }}
      />
    </div>
  )
}
